import React from 'react';
import { CATEGORY_PILLS } from './resourcesData';

const ResourcesFilterBar = ({ active, onChange }) => (
    <div className="lp-res-filterbar">
        <div className="lp-res-filterbar-inner">
            {CATEGORY_PILLS.map(pill => (
                <button key={pill} className={`lp-res-pill ${active === pill ? 'is-active' : ''}`} onClick={() => onChange(pill)}>{pill}</button>
            ))}
        </div>
    </div>
);

export default ResourcesFilterBar;
